/* eslint-disable array-callback-return */
import React, {useEffect, useState} from 'react';
import {TextField, OutlinedInput, Checkbox, ListItemText, SelectChangeEvent} from "@mui/material";
import CONSTANTS from '../../../shared/utils/Constants';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FormControl from '@mui/material/FormControl';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CustomButtonSecondary from '../../../shared/atomic_components/button/CustomButtonSecondary';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Fields, Subsections } from '../../../services/models/objs/StorSection';
import { GENERATEID } from '../../../shared/utils/Utils';
import 'dayjs/locale/it';


type SegnalazioneCreateSubsectionOrdineType = {
    segnalazioneChoiceLists : {[key : string] : any},
    notificationFunctions : any,
    setNewSegnalazione : any,
    fieldIsRequiredAndMissing : any,
    newStorHasFieldMissing : any,
    errorClickingNextSection : boolean,
    newSegnalazione : {[key : string] : any},
    storSectionName : string,
    storSubsectionStructure : Subsections
}

const SegnalazioneCreateSubsectionOrdine =  ({segnalazioneChoiceLists,
                                           notificationFunctions,
                                           setNewSegnalazione,
                                           fieldIsRequiredAndMissing,
                                           newStorHasFieldMissing,
                                           errorClickingNextSection,
                                           newSegnalazione,
                                           storSectionName,
                                           storSubsectionStructure } : SegnalazioneCreateSubsectionOrdineType) => {

    const [subsectionElement, setSubsectionElement] = useState<{[key : string] : any}>({})
    const [subsectionElements, setSubsectionElements] = useState<any[]>([])
    const [clickedAddButton, setClickedAddButton] = useState(false)
    const [codiceStrumFinanziario, setCodiceStrumFinanziario] = useState<any>('')
    const [orderDescription, setOrderDescription] = useState<any>(getDescription())  
    const [dateStart, setDateStart] = useState<Date>()
    const [dateEnd, setDateEnd] = useState<Date>() 
    const [supportStartHour, setsupportStartHour] = useState<Date>()
    const [supportEndHour, setsupportEndHour] = useState<Date>()       
    const [selectedField, setSelectedField] = useState<any>([])  
    
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const maxDate = new Date();
    const MenuProps = {
    PaperProps: {
        style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        },
    },
    };

    const handleChangeMultiInsertOption = (event : any) => {
        if (event.target.checked) {
            cleanDescrizioneOrdineAsObject()
            addFieldToSegnalazione('multiInsertOption', event.target.checked)
            if(orderDescription && orderDescription != '')
                addFieldToSegnalazione('descrizioneOrdine', orderDescription)
        }
        else
            cleanDescrizioneOrdineAsArray()
    };

    const handleChangeMultiInsertOptionForDataOrdine = (event : any) => {
        setDateStart(undefined);
        setDateEnd(undefined);
        if (event.target.checked) {
            cleanDescrizioneOrdineAsObject()
            addFieldToSegnalazione('multiInsertOptionForDataOrdine', event.target.checked)
            addFieldToSegnalazione('codiceStrumFinanaziario', 'all')
        }
        else
            cleanDescrizioneOrdineAsArray()
    }

    function cleanDescrizioneOrdineAsArray() {
        const tmpNewSegnalazione : {[key : string] : any} = {}
        Object.assign(tmpNewSegnalazione, newSegnalazione)
        tmpNewSegnalazione[storSectionName][storSubsectionStructure.id] = []
        setNewSegnalazione(tmpNewSegnalazione)
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewSegnalazione))
    }

    function cleanDescrizioneOrdineAsObject() {
        const tmpNewSegnalazione : {[key : string] : any} = {}
        Object.assign(tmpNewSegnalazione, newSegnalazione)
        tmpNewSegnalazione[storSectionName][storSubsectionStructure.id] = {}
        setNewSegnalazione(tmpNewSegnalazione)
    }

    function getDescription(){
        if(newSegnalazione && newSegnalazione['ordineOperazione'] && newSegnalazione['ordineOperazione']['descrStrumFinanziario'] && newSegnalazione['ordineOperazione']['descrStrumFinanziario'].length>0)
        {
            if(newSegnalazione['ordineOperazione']['descrStrumFinanziario'][0]['descrOperSospetteSup'])
                return newSegnalazione['ordineOperazione']['descrStrumFinanziario'][0]['descrOperSospetteSup']
            else if(newSegnalazione['ordineOperazione'] && newSegnalazione['ordineOperazione']['descrizioneOrdine'].descrizioneOrdine)
                return newSegnalazione['ordineOperazione']['descrizioneOrdine'].descrizioneOrdine
            else
                return ''
        }
        else
            return ''
    }

    useEffect(() => {
        if (newSegnalazione[storSectionName] && newSegnalazione[storSectionName][storSubsectionStructure.id]) {
            setSubsectionElements(newSegnalazione[storSectionName][storSubsectionStructure.id])
        }
    }, []) // [] means run only ones

    useEffect(()=>{},[orderDescription])

    function subsectionHandleChange(event : any, field : Fields) {
        if (storSubsectionStructure.multipleValue) {
            addFieldToSubsectionElement(field.name, event.target.value)
        }
        else {
            addFieldToSegnalazione(field.name, event.target.value)
        }
    }

    function subsectionHandleChangeChoice(event : any, field : Fields){
        let id = ''
        segnalazioneChoiceLists[field?.choiceListName || ''].forEach((list : any) => {
            if(event.target.value === list.name){
                id = list.id
            }
        });
        if(newSegnalazione[storSectionName][storSubsectionStructure.id].codiceStrumFinanaziario == 'all'){
            addFieldtoSegnalazioneMultipleId(field.name, event.target.value, id)
        }
        if (storSubsectionStructure.multipleValue) {
            addFieldToSubsectionElementChoice(field.name, event.target.value, id)
        }
        else {
            addFieldToSegnalazione(field.name, event.target.value)
        }
    }

    function subsectionHandleChangeMultiChoice(event: SelectChangeEvent<typeof selectedField>, field : Fields){     
        const { target: { value }} = event;
        let stringedValue = '';
        value.map((singleValue : string) =>{
            if(stringedValue === '')
                stringedValue = singleValue
            else
                stringedValue = stringedValue + ', ' + singleValue
        })
        setSelectedField(typeof value === 'string' ? value.split(',') : value);
        let id : string[] = []
        segnalazioneChoiceLists[field?.choiceListName || ''].forEach((list : any) => {
            value.map((singleValue : string) =>{
                if(singleValue === list.name){
                    id.push(list.id)
                }
            })
        });
        if(newSegnalazione[storSectionName][storSubsectionStructure.id].codiceStrumFinanaziario == 'all'){
            addFieldtoSegnalazioneMultipleId(field.name, stringedValue, id)
        }
        if (storSubsectionStructure.multipleValue) {
            addFieldToSubsectionElementChoice(field.name, stringedValue, id)
        }
    }

    function subsectionHandleChangeHourForm(field : Fields, hour : any) {
        let dateTMP = new Date(hour)
        let hourIsCorrect = true
        if(field.name === 'oraInizio'){
            if(dateEnd && dateStart && dateStart.toISOString() === dateEnd.toISOString() && supportEndHour && dateTMP>supportEndHour){
                hourIsCorrect = false
                notificationFunctions.setErrorMessage('Date e Ora di inzio devono essere antecedenti a quelli di fine')         
            }
            else{
                setsupportStartHour(dateTMP)
            }
        }
        if(field.name === 'oraFine'){
            if(dateEnd && dateStart && dateStart.toISOString() === dateEnd.toISOString() && supportStartHour && supportStartHour>dateTMP){
                hourIsCorrect = false
                notificationFunctions.setErrorMessage('Date e Ora di inzio devono essere antecedenti a quelli di fine')         
            }
            else{
                setsupportEndHour(dateTMP)
            }
        }
        let hourFormatted = ''
        if (Object.prototype.toString.call(dateTMP) === "[object Date]" && hour && hourIsCorrect) {
            hourFormatted = (dateTMP.getHours()<10?'0':'') + dateTMP.getHours() + ':' + (dateTMP.getMinutes()<10?'0':'') + dateTMP.getMinutes()
            if(newSegnalazione[storSectionName][storSubsectionStructure.id].codiceStrumFinanaziario == 'all'){
                addFieldToSegnalazione(field.name, hourFormatted)
            }
            else if (storSubsectionStructure.multipleValue)
                addFieldToSubsectionElement(field.name, hourFormatted)
            else
                addFieldToSegnalazione(field.name, hourFormatted)
        }
    }

    const addHours = (date: Date, hours: number): Date => {
        const result = new Date(date);
        result.setHours(0,0,0,0)
        result.setHours(result.getHours() + hours);
        return result;
    };

    function subsectionHandleChangeDateForm(field : Fields, date : any){
        let dateIsCorrect = true;
        if(field.name === 'dataInizio' ){
            if(dateEnd && date.toISOString() === dateEnd.toISOString() && supportStartHour && supportEndHour && supportStartHour>supportEndHour){
                dateIsCorrect = false
                notificationFunctions.setErrorMessage('Date e Ora di inzio devono essere antecedenti a quelli di fine')         
            }
            if(!dateEnd || (date <= dateEnd)){
                setDateStart(date)
            }
            else{
                dateIsCorrect = false
                notificationFunctions.setErrorMessage('Date e Ora di inzio devono essere antecedenti a quelli di fine')
            }
        }
        
        if(field.name === 'dataFine'){
            if(dateStart && date.toISOString() === dateStart.toISOString() && supportStartHour && supportEndHour && supportStartHour>supportEndHour){
                dateIsCorrect = false
                notificationFunctions.setErrorMessage('Date e Ora di inzio devono essere antecedenti a quelli di fine')         
            }
            if(!dateStart || (date >= dateStart)){
                setDateEnd(date)
            }        
            else{
                dateIsCorrect = false
                notificationFunctions.setErrorMessage("La data di fine deve essere successiva a quella di inizio")
            }
        }
        if(dateIsCorrect){
            let dateFormatted = date?.toISOString()
            if(dateFormatted)
                dateFormatted =  addHours(date, 2).toISOString()
            if(newSegnalazione[storSectionName][storSubsectionStructure.id].codiceStrumFinanaziario == 'all'){
                addFieldToSegnalazione(field.name, dateFormatted)
            }
            else if (storSubsectionStructure.multipleValue){
                addFieldToSubsectionElement(field.name, dateFormatted)
            }
            else
                addFieldToSegnalazione(field.name, dateFormatted)
        }
    }

    function addFieldToSubsectionElement(fieldName : string, value : any) {
        const tmpSubsectionElement : {[key : string] : any}= {}
        Object.assign(tmpSubsectionElement, subsectionElement)
        tmpSubsectionElement[fieldName] = value
        setSubsectionElement(tmpSubsectionElement)
        return tmpSubsectionElement
    }

    function addFieldToSubsectionElementChoice(fieldName : string, value : any, id : any) {
        const tmpSubsectionElement : {[key : string] : any}= {}
        Object.assign(tmpSubsectionElement, subsectionElement)
        tmpSubsectionElement[fieldName] = value
        tmpSubsectionElement[fieldName + 'Id'] = id
        setSubsectionElement(tmpSubsectionElement)
    }

    function addFieldtoSegnalazioneMultipleId(fieldName : string, value : any, id : any){
        const tmpNewStor : {[key : string] : any} = {}
        Object.assign(tmpNewStor, newSegnalazione)
        tmpNewStor[storSectionName][storSubsectionStructure.id][fieldName] = value
        tmpNewStor[storSectionName][storSubsectionStructure.id][fieldName + 'Id'] = id
        setNewSegnalazione(tmpNewStor)
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewStor))
    }

    function addFieldToSegnalazione(fieldName : string, value : any) {
        if(fieldName === 'descrizioneOrdine'){
            setOrderDescription(value)
        }
        const tmpNewStor : {[key : string] : any} = {}
        Object.assign(tmpNewStor, newSegnalazione)
        tmpNewStor[storSectionName][storSubsectionStructure.id][fieldName] = value
        setNewSegnalazione(tmpNewStor)
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewStor))
    }

    function getDate(field : Fields) {
        if(newSegnalazione[storSectionName][storSubsectionStructure.id].codiceStrumFinanaziario == 'all'){
            return new Date(newSegnalazione[storSectionName][storSubsectionStructure.id][field.name]) 
        }
        else if (storSubsectionStructure.multipleValue)
            return subsectionElement[field.name]? new Date(subsectionElement[field.name]) : null
        else if (newSegnalazione[storSectionName][storSubsectionStructure.id][field.name]) {
            return new Date(newSegnalazione[storSectionName][storSubsectionStructure.id][field.name])
        }
        else
            return null
    }

    function getHour(field : Fields) {
        let dateTMP = new Date()
        let value = ''
        if(newSegnalazione[storSectionName][storSubsectionStructure.id].codiceStrumFinanaziario == 'all'){
            value = newSegnalazione[storSectionName][storSubsectionStructure.id][field.name]? newSegnalazione[storSectionName][storSubsectionStructure.id][field.name] : null
            if(value){
                dateTMP.setHours(+value.slice(0,2))
                dateTMP.setMinutes(+value.slice(3,2))
                return dateTMP
            }
            else
                return null
        }
        else if (storSubsectionStructure.multipleValue){
            value = subsectionElement[field.name]? subsectionElement[field.name] : null
            if(value){
                dateTMP.setHours(+value.slice(0,2))
                dateTMP.setMinutes(+value.slice(3,5))
                return dateTMP
            }
            else
                return null
        }  
        else if (newSegnalazione[storSectionName][storSubsectionStructure.id][field.name]) {
            value = newSegnalazione[storSectionName][storSubsectionStructure.id][field.name]? newSegnalazione[storSectionName][storSubsectionStructure.id][field.name] : null
            if(value){
                dateTMP.setHours(+value.slice(0,2))
                dateTMP.setMinutes(+value.slice(3,2))
                return dateTMP
            }
            else
                return null
        }
        else return null
    }

    function checkDate(field : any) : boolean{
        let idString = ['dataScadenza','dataInizio','dataFine','dataRegolamento','dataNascita','dataInizioRelazioneProfessionale']
        let checkDate = false
        idString.forEach(id =>{
            if(field === id)
                checkDate=true;
        })
        return checkDate
    }

    function dateConvert(date : string){
        if(date){
            let newDate = new Date(date)
            return newDate.toLocaleDateString()
        }
        else 
            return null
    }

    function addSpecialSubsectionToSegnalazione() {
        if (!codiceStrumFinanziario)
            notificationFunctions.setErrorMessage('Selezionare lo strumento finanziario')
        else {
            const subsectionElementTmp = addFieldToSubsectionElement('codiceStrumFinanaziario', codiceStrumFinanziario)
            setCodiceStrumFinanziario('')
            setDateStart(undefined)
            setDateEnd(undefined)
            setSelectedField([])
            addSubsectionElement(subsectionElementTmp)
        }
    }

    function addSubsectionElement(subsectionElementTmp : any) {
        if (storSubsectionStructure.multipleValue && requiredFieldOfSubsectionElementIsMissing()) {
            setClickedAddButton(true)
            notificationFunctions.setErrorMessage(CONSTANTS.labelFillAllRequiredFields)
            return
        }
        setClickedAddButton(false)
        const tmpNewSegnalazione : {[key : string] : any}= {}
        Object.assign(tmpNewSegnalazione, newSegnalazione)
        const idGenerated = GENERATEID()
        if (subsectionElementTmp)
            subsectionElementTmp.id = idGenerated
        else
            subsectionElement.id = idGenerated
        tmpNewSegnalazione[storSectionName][storSubsectionStructure.id].push(subsectionElementTmp ? subsectionElementTmp : subsectionElement)
        setSubsectionElements(tmpNewSegnalazione[storSectionName][storSubsectionStructure.id])
        setNewSegnalazione(tmpNewSegnalazione)
        setSubsectionElement({})
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewSegnalazione))
    }

    function requiredFieldOfSubsectionElementIsMissing() {
        let numberOfRequiredFieldMissing = 0
        storSubsectionStructure.fields.map(field => {
            if (field.required && !subsectionElement[field.name])
                numberOfRequiredFieldMissing++
        })
        return numberOfRequiredFieldMissing > 0
    }

    function deleteSubsectionElement(element : any) {
        const tmpNewStor = {}
        Object.assign(tmpNewStor, newSegnalazione)
        const tmpSubsectionElements : any[] = []
        subsectionElements.map(subsectionElement => {
            if (subsectionElement.id !== element.id)
                tmpSubsectionElements.push(subsectionElement)
        })
        setSubsectionElements(tmpSubsectionElements)
        newSegnalazione[storSectionName][storSubsectionStructure.id] = tmpSubsectionElements
        setNewSegnalazione(newSegnalazione)
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewStor))
    }

    function checkErrorInField(field : Fields) {
        if (storSubsectionStructure.multipleValue){
            return clickedAddButton && field.required && !subsectionElement[field.name]
        }
        else
            return fieldIsRequiredAndMissing(storSectionName, storSubsectionStructure.id, field)
    }

    function getFormValueFromFieldName(fieldName : string) {
        if(fieldName === 'descrizioneOrdine'){
            return orderDescription
        }
        else if (storSubsectionStructure.multipleValue) {
            return subsectionElement[fieldName] ? subsectionElement[fieldName] : ""
        }
        else if (newStorHasFieldMissing(storSectionName, storSubsectionStructure.id, fieldName))
            return ""
        else
            return newSegnalazione[storSectionName][storSubsectionStructure.id][fieldName]
    }

    function renderForm(field : Fields) {
        switch (field.type) {
            case "text":
                return renderTextForm(field)
            case "number":
                return renderNumberForm(field)
            case "date":
                return renderDateForm(field)
            case "textArea":
                return renderTextAreaForm(field)
            case "hour":
                return renderHourForm(field)
            case "choice":
                return renderChoiceForm(field)
            case "multiChoice":
                return renderMultiChoiceForm(field)
        }
    }

    const renderTextForm = (field : Fields) => {
        return <TextField
            error={checkErrorInField(field)}
            helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
            onChange={(event => {subsectionHandleChange(event, field)})}
            required={field.required}
            fullWidth={true}
            value={getFormValueFromFieldName(field.name)}
            id={field.name}
            label={field.label}
            inputProps={{maxLength:field.max}}
        />
    }

    const renderNumberForm = (field : Fields) => {
        return <TextField
            type = "number"
            error={checkErrorInField(field)}
            helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
            onChange={(event => {subsectionHandleChange(event, field)})}
            required={field.required}
            fullWidth={true}
            value={getFormValueFromFieldName(field.name)}
            id={field.name}
            label={field.label}
            // inputProps={{ inputMode: 'numeric',  pattern: '[0-9]*' }}
        />
    }

    const renderTextAreaForm = (field : Fields) => {
        return <TextField
            rows={3}
            multiline
            error={checkErrorInField(field)}
            helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
            onChange={(event => {subsectionHandleChange(event, field)})}
            required={field.required}
            fullWidth={true}
            value={getFormValueFromFieldName(field.name)}
            id={field.name}
            label={field.label}
            inputProps={{maxLength:field.max}}
        />
    }

    const renderDateForm = (field : Fields) => {
        return <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'it'}>
            <MobileDatePicker
                componentsProps={{
                    actionBar: {
                        actions: ['clear','accept']
                    }
                }}
                label={field.label}
                value={getDate(field)}
                maxDate={(field.name === 'dataInizio' || field.name === 'dataFine')? maxDate : new Date('2099-12-31')}
                onChange={(date) => {
                    subsectionHandleChangeDateForm(field, date);
                }}
                renderInput={(params) => <TextField {...params}
                    error={checkErrorInField(field)}
                    helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
                    required={field.required}
                    fullWidth
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <EventIcon/>
                        </InputAdornment>,
                    }}/>
                }
            />
        </LocalizationProvider>
    }



    const renderHourForm = (field : Fields) => {
        return <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'it'}>
            <MobileTimePicker
                label={field.label}
                value={getHour(field)}
                onChange={(hour : any) => {
                    subsectionHandleChangeHourForm(field, hour);
                }}
                renderInput={(params : any) => <TextField {...params}
                    error={checkErrorInField(field)}
                    helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
                    required={field.required}
                    fullWidth
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <AccessTimeIcon/>
                        </InputAdornment>,
                    }}/>
                }
            />
        </LocalizationProvider>
    }

    const renderChoiceForm = (field : Fields) => {
        return <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{field.required? field.label + " *" : field.label}</InputLabel>
            <Select
                value={getFormValueFromFieldName(field.name)}
                label={field.label}
                onChange={(event => {subsectionHandleChangeChoice(event, field)})}>
                <MenuItem key="" value="">{'-Seleziona-'}</MenuItem>
                {segnalazioneChoiceLists[field?.choiceListName || ''].map((choice : any) => {
                    return <MenuItem key={choice.id} value={choice.name}>
                        <ListItemText primary={choice.name} />
                    </MenuItem>
                })}
            </Select>
        </FormControl>
    }

    const renderMultiChoiceForm = (field : Fields) => {
        return <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{field.required? field.label + " *" : field.label}</InputLabel>
            <Select
                multiple
                label={field.label}
                value={selectedField}
                onChange={(event => {subsectionHandleChangeMultiChoice(event, field)})}
                // input={<OutlinedInput label="Tag" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}>
                {segnalazioneChoiceLists[field?.choiceListName || ''].map((choice : any) => {
                    return <MenuItem key={choice.id} value={choice.name}>
                        <Checkbox checked={selectedField.indexOf(choice.name) > -1} />
                        <ListItemText primary={choice.name} />
                    </MenuItem>
                })}
            </Select>
        </FormControl>
    }

    return (
        <>
            {storSubsectionStructure.id === 'descrizioneOrdine' ?
                <FormGroup className="mt-4">
                    <FormControlLabel
                        control={<Switch checked={newSegnalazione[storSectionName][storSubsectionStructure.id]['multiInsertOption']}
                                         onChange={handleChangeMultiInsertOption} />} label="Inserimento multiplo" />
                </FormGroup>
                :
                <></>
            }
            {storSubsectionStructure.id === 'dataOraOrdine' ?
                <FormGroup className="mt-4">
                    <FormControlLabel
                        control={<Switch checked={newSegnalazione[storSectionName][storSubsectionStructure.id]['multiInsertOption']}
                                         onChange={handleChangeMultiInsertOptionForDataOrdine} />} label="Applica a tutti gli strumenti finanziari" />
                </FormGroup>
                :
                <></>
            }
            {storSubsectionStructure.id === 'nazione' ?
                <FormGroup className="mt-4">
                    <FormControlLabel
                        control={<Switch checked={newSegnalazione[storSectionName][storSubsectionStructure.id]['multiInsertOption']}
                                         onChange={handleChangeMultiInsertOptionForDataOrdine} />} label="Applica a tutti gli strumenti finanziari" />
                </FormGroup>
                :
                <></>
            }
            <div className="mt-4 mb-4 row">
                {newSegnalazione[storSectionName][storSubsectionStructure.id]['multiInsertOption'] ?
                    <div>
                        <span>Inserire una descrizione dettagliata degli ordini effettuati ed allegare il file a supporto delle informazione nella sezione <strong>Documentazione allegata</strong></span>
                        <TextField
                            className="mt-4"
                            rows={4}
                            multiline
                            required={false}
                            defaultValue={getFormValueFromFieldName('descrizioneOrdine')}
                            onChange={(event) => {addFieldToSegnalazione('descrizioneOrdine', event.target.value)}}
                            fullWidth={true}
                            label="Descrizione dell'ordine (max 2500 caratteri)"
                            inputProps={{maxLength:2500}}
                        />
                    </div>
                    :
                    <div className="row">
                        {!newSegnalazione[storSectionName][storSubsectionStructure.id]['multiInsertOptionForDataOrdine'] ?
                        <div className="col-3">
                            <FormControl className="mt-3" fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Codice identificativo dello strumento
                                </InputLabel>
                                <Select
                                    value={codiceStrumFinanziario}
                                    onChange={(event) => {
                                        setCodiceStrumFinanziario(event.target.value)
                                    }}
                                    label="Codice identificativo dello strumento">
                                    <MenuItem key="" value="">{'-Seleziona-'}</MenuItem>
                                    {newSegnalazione['ordineOperazione']['descrStrumFinanziario'].map((strumento : any) => {
                                        return <MenuItem key={strumento.codiceIdentificativo}
                                                            value={strumento.codiceIdentificativo}>
                                            {strumento.codiceIdentificativo}
                                        </MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                        :
                        <></>
                    }
                    {storSubsectionStructure.fields.map(field => {
                        return <div key={field.name} className={"col-md-" + field.numColMd + " mt-3 col-sm-12"}>
                            {renderForm(field)}
                        </div>})}
                </div>
                }
            </div>
            {storSubsectionStructure.multipleValue
                && !newSegnalazione[storSectionName][storSubsectionStructure.id]['multiInsertOption']
                && !newSegnalazione[storSectionName][storSubsectionStructure.id]['multiInsertOptionForDataOrdine']?
                <div className="col-12 text-center">
                    <CustomButtonSecondary onClick={() => {addSpecialSubsectionToSegnalazione()}}>Aggiungi</CustomButtonSecondary>
                </div>
                :
                <></>
            }
            {subsectionElements && subsectionElements.length > 0 ? subsectionElements.map(subsectionElement => {
                return <div key={subsectionElement.id}>
                    <div className="row mt-3">
                        <div className="card-body row">
                            <div className="row">
                                <div className="mt-3 font-medium-custom text-bold col-6 mb-3">
                                    <span className="margin-right-5">{storSubsectionStructure.labelForAddedValues}</span>
                                    <span className="pointer color-delete">
                                        <DeleteOutlineOutlinedIcon className="" onClick={() => deleteSubsectionElement(subsectionElement)}/>
                                    </span>
                                </div>
                            </div>
                            <div className="row mt-3 col-md-3">
                                <span>
                                    <strong className="margin-right-5">Codice strumento finanziario:</strong>
                                    {subsectionElement['codiceStrumFinanaziario']}
                                </span>
                            </div>
                            {storSubsectionStructure.fields.map(field => {
                                return <div key={field.name} className="row mt-3 col-md-3">
                                    {checkDate(field.name) ?
                                        <span><strong className="margin-right-5">{field.label}:</strong> {dateConvert(subsectionElement[field.name])}</span>
                                        :
                                        <span><strong className="margin-right-5">{field.label}:</strong> {subsectionElement[field.name]}</span>
                                    }
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            }) : <></>}
        </>
    )
}

export default SegnalazioneCreateSubsectionOrdine;
